import CpiChip from './CpiChip'

export default CpiChip
